import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { metadataService } from "../../_services";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  Row,
  Col,
} from "reactstrap";
import { SlBusyIndicator } from "../editors";
import { BsDownload } from "react-icons/bs";
const DocumentList = ({
  dataSource = [],
  openFileNewTab,
  leftContent,
  documentUpdatedId,
  showDownloadIcon = false,
}) => {
  return (
    <ListGroup>
      {dataSource.map((content) => {
        const {          
          documentStatusId,
          creationTime,
          modifiedTime,
          documentName,
          originName,
          documentRejectReasonText,
          id,
        } = content;
        const statusLookup = metadataService.getLookupAsHashMap("documentStatus");
        return (
          <ListGroupItem>
            <ListGroupItemHeading>
              <Row className="justify-content-center">
                <Col lg={3} sm={12} className="mb-3">
                  {leftContent}
                </Col>
                <Col lg={showDownloadIcon ? 6 : 9} sm={12}  className="mb-3">
                  <p>
                    {metadataService.getMessage(
                      "DocumentName",
                      originName || documentName || ""
                    )}
                  </p>
                  <p>
                    {metadataService.getMessage(
                      "DocumentStatus",
                      (statusLookup[documentStatusId] || "") +
                        (documentRejectReasonText &&
                        documentRejectReasonText !== ""
                          ? ` (${documentRejectReasonText})`
                          : "")
                    )}
                  </p>
                  <p>
                    <small>
                      {metadataService.getMessage(
                        "UpdatedAt",
                        moment(creationTime) > moment(modifiedTime)
                          ? metadataService.formatDateString(creationTime)
                          : metadataService.formatDateString(modifiedTime)
                      )}
                    </small>
                  </p>
                </Col>
                {showDownloadIcon && (
                  <Col lg={3} sm={12} className="text-right mb-3">
                    {documentUpdatedId != id ? (
                      <i
                        className="cursor-pointer"
                        onClick={(e) => openFileNewTab(content)}
                      >
                        <BsDownload size={20} />
                      </i>
                    ) : (
                      <i style={{ fontSize: "18px" }}>
                        <SlBusyIndicator visible={true} className="" />
                      </i>
                    )}
                  </Col>
                )}
              </Row>
            </ListGroupItemHeading>
          </ListGroupItem>
        );
      })}
    </ListGroup>
  );
};

DocumentList.propTypes = {
  dataSource: PropTypes.array,
  openFileNewTab: PropTypes.func,
};
const mapStateToProps = (state) => {
  const { language } = state.users;
  const { documentUpdatedId } = state.documents;
  return { language, documentUpdatedId };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentList);



// WEBPACK FOOTER //
// ./src/components/subcomponents/DocumentList.jsx